import type { DateDataTypeDefinition } from 'ag-grid-community';

export type GridDateTimeFormatters = {
  formatDateTime: (value: Date) => string;
  formatDateTimeWithSeconds?: (value: Date) => string;
};

// DateDataTypeDefinition rather than the broad DataTypeDefinition union: it pins the value type to Date, so callers
// (and tests) of the valueFormatter get one concrete params type instead of the union members' intersection.
export type GridDateTimeDataTypeDefinitions = {
  dateTime: DateDataTypeDefinition<unknown>;
  dateTimeWithSeconds: DateDataTypeDefinition<unknown>;
};

export const createGridDateTimeDataTypeDefinitions = ({
  formatDateTime,
  formatDateTimeWithSeconds = formatDateTime,
}: GridDateTimeFormatters): GridDateTimeDataTypeDefinitions => ({
  dateTime: {
    baseDataType: 'date',
    extendsDataType: 'date',
    valueFormatter: ({ value }) => {
      if (!value) {
        return '-';
      }

      return formatDateTime(value);
    },
  },
  dateTimeWithSeconds: {
    baseDataType: 'date',
    extendsDataType: 'date',
    valueFormatter: ({ value }) => {
      if (!value) {
        return '-';
      }

      return formatDateTimeWithSeconds(value);
    },
  },
});
